import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { deliveryAddressAPI } from '../../api/config';
import * as types from '../constants/actionTypes';
import * as actions from '../actions/deliveryAddressActions';

// Fetch Delivery Addresses Saga
function* fetchDeliveryAddressesSaga(action) {
  try {
    const response = yield call(deliveryAddressAPI.fetchDeliveryAddresses, action.payload.filters);
    const { delivery_addresses, total_count } = response.data;
    
    yield put(actions.fetchDeliveryAddressesSuccess(delivery_addresses, total_count));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch delivery addresses';
    yield put(actions.fetchDeliveryAddressesFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Create Delivery Address Saga
function* createDeliveryAddressSaga(action) {
  try {
    const response = yield call(deliveryAddressAPI.createDeliveryAddress, action.payload.addressData);
    const { delivery_address } = response.data;
    
    yield put(actions.createDeliveryAddressSuccess(delivery_address));
    message.success('Delivery address created successfully');
    
    // Refresh the list
    yield put(actions.fetchDeliveryAddressesRequest({}));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to create delivery address';
    yield put(actions.createDeliveryAddressFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Update Delivery Address Saga
function* updateDeliveryAddressSaga(action) {
  try {
    const { id, addressData } = action.payload;
    const response = yield call(deliveryAddressAPI.updateDeliveryAddress, id, addressData);
    const { delivery_address } = response.data;
    
    yield put(actions.updateDeliveryAddressSuccess(delivery_address));
    message.success('Delivery address updated successfully');
    
    // Refresh the list
    yield put(actions.fetchDeliveryAddressesRequest({}));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to update delivery address';
    yield put(actions.updateDeliveryAddressFailure(errorMessage));
    message.error(errorMessage);
  }
}

export default function* deliveryAddressSaga() {
  yield takeEvery(types.FETCH_DELIVERY_ADDRESSES_REQUEST, fetchDeliveryAddressesSaga);
  yield takeEvery(types.CREATE_DELIVERY_ADDRESS_REQUEST, createDeliveryAddressSaga);
  yield takeEvery(types.UPDATE_DELIVERY_ADDRESS_REQUEST, updateDeliveryAddressSaga);
}